export default function Modal() {
  // data-modal-srcがついた要素を取得
  const modalElement = document.querySelectorAll('[data-modal-src]');

  // モーダル対象があった時のみ、モーダルのDOMを生成
  if (modalElement) {
    // モーダルの各要素にクリックイベントを設定
    modalElement.forEach((el) => {
      const videoURL = el.dataset.modalSrc;
      el.addEventListener('click', function () {
        openModal(videoURL);
      });
    });

    // モーダル要素を作成
    let modal = document.createElement('div');
    modal.className = 'o-movie-modal';
    modal.classList.add('js-modal');
    modal.addEventListener('click', function (event) {
      if (event.target === modal) {
        closeModal();
      }
    });
    // modalContentの要素を作成
    let modalContent = document.createElement('div');
    modalContent.className = 'o-movie-modal__video';
    // iframeのYouTube要素を作成
    let videoPlayer = document.createElement('iframe');
    videoPlayer.className = 'js-modal-video';
    videoPlayer.width = '560';
    videoPlayer.height = '315';
    videoPlayer.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    videoPlayer.allowFullscreen = true;
    // 閉じるボタンを作成
    let closeBtn = document.createElement('button');
    closeBtn.className = 'o-movie-modal__button-close';
    closeBtn.setAttribute('aria-label', '閉じる');
    closeBtn.innerHTML = `
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <mask id='mask0_8286_2615' style='mask-type:alpha' maskUnits='userSpaceOnUse' x='0' y='0' width='24' height='24'>
        <rect width='24' height='24' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_8286_2615)'>
        <path
          d='M6.40009 19.1911L4.80884 17.5998L10.4088 11.9998L4.80884 6.39984L6.40009 4.80859L12.0001 10.4086L17.6001 4.80859L19.1913 6.39984L13.5913 11.9998L19.1913 17.5998L17.6001 19.1911L12.0001 13.5911L6.40009 19.1911Z'
          fill='white'
        />
      </g>
    </svg>
    `;

    // 閉じるボタンにクリックイベントを設定
    closeBtn.addEventListener('click', closeModal);

    // modalの中身に各要素を追加
    modalContent.appendChild(videoPlayer);
    modalContent.appendChild(closeBtn);
    modal.appendChild(modalContent);
    document.body.appendChild(modal);
  }
  // モーダルを開く
  function openModal(videoURL) {
    let modal = document.querySelector('.js-modal');
    let videoPlayer = document.querySelector('.js-modal-video');

    videoPlayer.src = videoURL;
    modal.classList.add('is-open');
  }
  // モーダルを閉じる
  function closeModal() {
    let modal = document.querySelector('.js-modal');
    let videoPlayer = document.querySelector('.js-modal-video');
    // 次に入ってくるsrcのために空にしておく
    videoPlayer.src = '';
    modal.classList.remove('is-open');
  }
}
